// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
  gap: 8px;
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-position=inline-start]) .ids-input + .validation-message,
:host([label-position=inline-start]) .ids-textarea + .validation-message {
  min-width: min-content;
  margin-block-start: calc(0px - var(--ids-space-2xs));
  margin-inline-start: calc(var(--ids-label-width) + 6px);
}
:host([label-position=inline-start]) .ids-input.xs + .validation-message,
:host([label-position=inline-start]) .ids-textarea.xs + .validation-message {
  position: relative;
  inset-inline-start: 6px;
  margin-inline-start: calc(var(--ids-label-width));
}
:host([label-position=inline-start]) .ids-input .ids-label-text,
:host([label-position=inline-start]) .ids-textarea .ids-label-text {
  margin-bottom: unset;
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 767px) {
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  container-type: inline-size;
  margin-top: var(--ids-space-00);
}
@container (width >= 200px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after {
  margin-inline-end: 0;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input:not(.xs),
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input:not(.xs) {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    flex-wrap: wrap;
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-radio-group,
  :host([label-position=inline-end]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-start]) .ids-radio-group ids-text.group-label-text,
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-radio-group slot,
  :host([label-position=inline-end]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
  }
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    justify-content: end;
    order: 2;
  }
  :host([label-position=inline-end]) .ids-radio-group slot {
    order: 1;
  }
}
@media (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: 45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

:host([size=full]:not([label-position=inline-start])) {
  width: 100%;
}
:host([size=full]:not([label-position=inline-start])) ::part(container) {
  display: block;
}

.ids-date-picker {
  display: inline-block;
  max-width: 100%;
  position: relative;
}
.ids-date-picker ids-trigger-field,
.ids-date-picker .ids-trigger-field {
  display: inline-block;
  max-width: 100%;
}
.ids-date-picker ids-trigger-field[size=full] {
  display: block;
}
.ids-date-picker.full {
  display: block;
}
.ids-date-picker.full ids-trigger-field,
.ids-date-picker.full .ids-trigger-field {
  display: block;
}
.ids-date-picker.full ids-trigger-field::part(container),
.ids-date-picker.full .ids-trigger-field::part(container) {
  flex-basis: 100%;
}
.ids-date-picker ids-trigger-button[field-height=xs] {
  margin-inline-end: 2px;
}
.ids-date-picker ids-trigger-button[field-height=xs]::part(button) {
  inset-inline-start: unset;
}
.ids-date-picker ids-trigger-button[field-height=md] {
  margin-inline-end: 2px;
}
.ids-date-picker ids-trigger-button.xs, .ids-date-picker ids-trigger-button.md {
  margin-top: -2px;
}
.ids-date-picker ids-trigger-button.sm {
  margin-top: -1px;
}
.ids-date-picker ids-trigger-button::part(button) {
  block-size: 28px;
  inline-size: 28px;
  margin-inline-start: -10px;
  inset-inline-end: -1px;
  color: var(--ids-date-picker-icon-color);
  position: relative;
}
.ids-date-picker ids-trigger-button[compact] {
  margin-inline-end: 2px;
  width: 24px;
  height: 24px;
}
.ids-date-picker.is-open:not(.is-dropdown) ids-trigger-button::part(button) {
  color: var(--ids-date-picker-open-trigger-button-color-text);
}
.ids-date-picker.is-open:not(.is-dropdown) ids-trigger-field::part(field-container) {
  border-color: var(--ids-date-picker-color-border);
}
.ids-date-picker ids-month-view {
  width: 100%;
}
.ids-date-picker:not(.has-time) ids-month-view::part(table-container) {
  margin-bottom: 10px;
}
.ids-date-picker ids-popup::part(popup) {
  padding-top: 0;
  padding-bottom: 0;
}
.ids-date-picker .popup-footer {
  display: flex;
}
.ids-date-picker .popup-btn {
  width: 100%;
}
.ids-date-picker .popup-btn::part(button) {
  display: flex;
  padding-block: var(--ids-space-12);
  border-radius: 0;
  justify-content: center;
}
.ids-date-picker .popup-btn::part(button):not(:focus) {
  border: 1px solid transparent;
  border-top-color: var(--ids-date-picker-popup-button-color-border);
}
.ids-date-picker .popup-btn:not(.popup-btn-apply)::part(button) {
  color: var(--ids-date-picker-popup-button-color-text-default);
}
.ids-date-picker .popup-btn:not(.popup-btn-apply)::part(button):hover {
  color: var(--ids-date-picker-popup-button-color-text-hover);
}
.ids-date-picker .popup-btn:not([hidden]):not(:last-child):not(:focus)::part(button) {
  border-inline-end-color: var(--ids-date-picker-popup-button-color-border);
}
.ids-date-picker .popup-btn-apply:not([disabled])::part(button) {
  color: var(--ids-date-picker-popup-button-primary-color-text);
}
.ids-date-picker .popup-btn-apply[disabled]::part(button) {
  color: var(--ids-date-picker-popup-button-primary-color-text-disabled);
}
.ids-date-picker ids-time-picker {
  display: flex;
  justify-content: center;
}
.ids-date-picker.field-height-xs ids-trigger-field, .ids-date-picker.field-height-sm ids-trigger-field, .ids-date-picker.field-height-md ids-trigger-field, .ids-date-picker.field-height-lg ids-trigger-field {
  display: flex;
}

.ids-date-picker.is-dropdown .dropdown-btn::part(button) {
  color: var(--ids-date-picker-dropdown-button-color-text);
  padding: 4px;
  border: none;
  border-radius: var(--ids-border-radius-2xs);
}
.ids-date-picker.is-dropdown .dropdown-btn::part(button):focus {
  box-shadow: 0 0 0 2px transparent, 0 0 0 1px var(--ids-date-picker-dropdown-color-focus), 0 0 4px 3px rgba(54, 138, 192, 0.3);
}
.ids-date-picker.is-dropdown .dropdown-btn-text,
.ids-date-picker.is-dropdown .dropdown-btn-icon {
  padding-inline-start: 0;
}
.ids-date-picker.is-dropdown .dropdown-btn-icon {
  margin-top: 2px;
}
.ids-date-picker.is-dropdown.is-expanded .dropdown-btn::part(button) {
  color: var(--ids-button-tertiary-color-text-hover);
}
.ids-date-picker.is-dropdown.is-expanded .dropdown-btn-icon {
  transform: rotate(180deg);
}
.ids-date-picker.is-dropdown ids-expandable-area::part(container) {
  margin: 0;
  padding: 0;
  width: 100%;
  position: absolute;
  z-index: 3;
  border: none;
  top: 43px;
  left: 0;
}
.ids-date-picker.is-dropdown ids-expandable-area::part(header) {
  display: none;
}
.ids-date-picker.is-dropdown ids-expandable-area::part(pane) {
  background-color: var(--ids-color-background-default);
}
.ids-date-picker.is-dropdown ids-expandable-area::part(pane-content) {
  margin-top: 0;
}
.ids-date-picker.is-dropdown .picklist {
  display: flex;
}
.ids-date-picker.is-dropdown .picklist::after {
  background-color: var(--ids-date-picker-picklist-separator-color-background);
  position: absolute;
  content: " ";
  width: 1px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: calc(75% + 14px);
  top: calc(12.5% - 4px);
}
.ids-date-picker.is-dropdown:not(.is-expanded) .picklist::after {
  background-color: var(--ids-color-transparent);
}
.ids-date-picker.is-dropdown .picklist-section {
  height: 100%;
  width: 50%;
  flex: 0 0 50%;
}
.ids-date-picker.is-dropdown .picklist-list {
  display: flex;
  list-style: none;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 100%;
}
.ids-date-picker.is-dropdown .picklist-item {
  border: 1px solid transparent;
  box-sizing: border-box;
  display: flex;
  cursor: var(--ids-cursor-pointer);
  color: var(--ids-date-picker-picklist-item-color-text-default);
  padding-top: 1px;
  padding-bottom: 1px;
  user-select: none;
  height: 12.5%;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.ids-date-picker.is-dropdown .picklist-item ids-text {
  line-height: 0;
}
.ids-date-picker.is-dropdown .picklist-item.is-selected {
  color: var(--ids-date-picker-picklist-item-color-text-selected);
  background-color: var(--ids-date-picker-picklist-item-color-background-selected);
}
.ids-date-picker.is-dropdown .picklist-item.is-selected ids-text::part(text) {
  font-weight: 600;
}
.ids-date-picker.is-dropdown .picklist-item:focus {
  border-color: var(--ids-date-picker-item-color-border-focus);
  box-shadow: var(--ids-date-picker-item-shadow-focus);
  outline: none;
}
.ids-date-picker.is-dropdown .picklist-item.is-year-nav, .ids-date-picker.is-dropdown .picklist-item.is-month-nav {
  z-index: 1;
}
.ids-date-picker.is-dropdown .picklist-item.is-month-nav {
  width: calc(100% + 1px);
}

:host([is-calendar-toolbar=true]) {
  display: flex;
}

:host([dir=rtl]) .ids-date-picker .popup-btn + .popup-btn::part(button):not(:focus) {
  border-left-color: var(--ids-color-transparent);
}

.ids-date-picker.color-variant-borderless ids-trigger-field::part(container) {
  margin: 1px 0;
}
.ids-date-picker.color-variant-borderless ids-trigger-field::part(field-container) {
  border: none;
}
.ids-date-picker.color-variant-borderless ids-trigger-field::part(input) {
  padding-inline-end: 0 !important;
}
.ids-date-picker.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 16px;
  height: 50px;
}
.ids-date-picker.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 40px;
}
.ids-date-picker.color-variant-borderless.field-height-sm ids-trigger-field::part(container) {
  display: flex;
}
.ids-date-picker.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 8px;
  height: 35px;
}
.ids-date-picker.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 4px;
  height: 30px;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

@media (width <= 767px) {
  :host(:not([label-position=inline-start])) ids-trigger-field::part(container),
  :host(:not([label-position=inline-start])) ids-input::part(container) {
    flex-direction: column;
    align-items: flex-start;
  }
  :host(:not([label-position=inline-start])) ids-trigger-field:not(.ids-date-picker ids-trigger-field)::part(field-container),
  :host(:not([label-position=inline-start])) ids-input::part(field-container) {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/themes/mixins/ids-label-position-mixin.scss","webpack://./src/components/ids-date-picker/ids-date-picker.scss","webpack://./src/themes/mixins/ids-field-indicator-mixin.scss"],"names":[],"mappings":"AAKE;;EAEE,aAAA;EACA,6CAAA;EACA,QAAA;ACJJ;ADOI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;ACJN;ADQI;;EACE,WAAA;EACA,wCAAA;ACLN;ADOM;EAJF;;IAKI,sBAAA;ECHN;AACF;ADMI;;EACE,sBAAA;EACA,oDAAA;EACA,uDAAA;ACHN;ADMI;;EACE,kBAAA;EACA,uBAAA;EACA,iDAAA;ACHN;ADMI;;EACE,oBAAA;ACHN;ADKM;EAHF;;IAII,oBAAA;ECDN;AACF;ADGM;EAPF;;IAQI,oBAAA;ECCN;AACF;ADEI;EACE;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;ECCN;EDEI;;IACE,QAAA;ECCN;EDEI;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;ECCN;EDGM;;IACE,oDAAA;IACA,uDAAA;ECAR;AACF;ADME;EACE,2BAAA;EACA,+BAAA;ACJJ;ADMI;EAJF;IAKI,aAAA;IACA,eAAA;IACA,+CAAA;ECHJ;EDMI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;ECLN;EDQI;IACE,OAAA;ECNN;EDSI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;ECPN;EDUI;IACE,WAAA;IACA,yBAAA;ECRN;EDWI;IACE,WAAA;ECTN;AACF;;ADgBE;EACE,sBAAA;ACbJ;ADeI;EAHF;IAII,aAAA;IACA,eAAA;IACA,+CAAA;ECZJ;EDcI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;ECbN;EDgBI;IACE,OAAA;ECdN;EDiBI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;ECfN;EDkBI;IACE,WAAA;IACA,yBAAA;EChBN;EDmBI;IACE,WAAA;ECjBN;AACF;;ADyBI;;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;ACrBN;ADuBM;EALF;;IAMI,2BAAA;ECnBN;AACF;ADqBM;EATF;;IAUI,2BAAA;ECjBN;AACF;ADoBQ;;EACE,oBAAA;ACjBV;ADsBI;EAtBF;;IAuBI,cAAA;EClBJ;AACF;ADoBI;EA1BF;;IA2BI,cAAA;EChBJ;AACF;ADmBE;EACE,OAAA;ACjBJ;;ADwBE;;;;EAEE,aAAA;EACA,iBAAA;ACnBJ;ADqBI;;;;EACE,cAAA;AChBN;ADmBI;;;;EACE,YAAA;EACA,cAAA;ACdN;ADkBI;;;;EACE,WAAA;EACA,sBAAA;ACbN;ADiBE;;EACE,+BAAA;ACdJ;;ADoBE;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,sCAAA;ACjBJ;ADmBI;;EACE,cAAA;EACA,WAAA;AChBN;ADmBI;;EACE,cAAA;EACA,WAAA;EACA,YAAA;AChBN;ADmBI;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;AChBN;ADmBI;;EACE,cAAA;EACA,sBAAA;AChBN;;ADsBE;EACE;IACE,aAAA;IACA,+CAAA;ECnBJ;EDqBI;IACE,6BAAA;IACA,cAAA;ECnBN;EDsBI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;ECpBN;AACF;ADwBE;EACE;;IAEE,cAAA;ECtBJ;AACF;ADyBE;EACE;;IAEE,eAAA;ECvBJ;AACF;;AD4BE;EACE;IACE,aAAA;IACA,+CAAA;ECzBJ;ED2BI;IACE,6BAAA;IACA,cAAA;ECzBN;ED4BI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EC1BN;AACF;;ADgCE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AC7BJ;AD+BI;;EACE,WAAA;EACA,cAAA;AC5BN;AD+BI;;EACE,YAAA;EACA,cAAA;AC5BN;ADgCI;;EACE,WAAA;EACA,sBAAA;AC7BN;;ADqCE;;EACE,aAAA;ACjCJ;;ADwCE;;EAEE,aAAA;ACrCJ;ADuCI;;EACE,cAAA;EACA,QAAA;ACpCN;ADuCI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;ACpCN;ADwCE;EACE,+BAAA;ACtCJ;;AD2CE;EACE;IACE,aAAA;IACA,+CAAA;ECxCJ;ED0CI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;ECxCN;ED2CI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;ECzCN;AACF;;AD+CE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AC5CJ;AD8CI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;AC3CN;AD8CI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AC3CN;AD+CI;;EACE,sBAAA;EACA,QAAA;AC5CN;ADgDE;EACE,+BAAA;AC9CJ;;ADkDA;EACE,sDAAA;AC/CF;;ADwDI;;;;EACE,4CAAA;AClDN;ADqDI;;;;EACE,iBAAA;AChDN;;ADsDA;EAEI;IACE,+CAAA;ECpDJ;EDsDI;IACE,2CAAA;ECpDN;AACF;AD0DA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;ECzDJ;ED2DI;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;ECzDN;ED6DI;IACE,kBAAA;IACA,0CAAA;EC3DN;ED+DI;IACE,WAAA;IACA,wCAAA;EC7DN;AACF;ADoEE;EAEI;IACE,4CAAA;ECnEN;EDsEI;IACE,4BAAA;ECpEN;AACF;;ADyEA;EAEI;IACE,cAAA;ECvEJ;ED0EE;IACE,qBAAA;ECxEJ;AACF;AD8EA;EAGI;;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;EC7EJ;ED+EI;;IACE,iCAAA;EC5EN;ED+EI;;IACE,aAAA;IACA,sBAAA;EC5EN;EDkFE;IACE,oBAAA;IACA,QAAA;EChFJ;EDmFE;IACE,QAAA;ECjFJ;AACF;ADsFA;EAEI;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;IACA,sBAAA;ECrFJ;EDuFI;IACE,iCAAA;IACA,QAAA;ECrFN;EDwFI;IACE,aAAA;IACA,sBAAA;IACA,QAAA;ECtFN;AACF;AD4FA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EC1FF;ED4FE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;EC1FJ;ED6FE;IACE,WAAA;IACA,YAAA;EC3FJ;EDgGE;IACE,UAAA;IACA,cAAA;EC9FJ;AACF;ADmGA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;ECjGF;EDmGE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;ECjGJ;EDoGE;;IAEE,aAAA;IACA,6CAAA;EClGJ;AACF;ADuGA;EAEI;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;ECtGJ;EDwGI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ECpGN;EDuGI;;;IACE,sBAAA;ECnGN;EDyGE;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;ECvGJ;EDyGI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ECrGN;EDwGI;;;IACE,sBAAA;ECpGN;AACF;ADkHI;;;;;;;;;;;;;;EAEE,6BAAA;ACpGN;;ACrkBA;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;ADwkBF;ACtkBE;EACE,wBAAA;EACA,MAAA;ADwkBJ;;ACpkBA;EACE,yDAAA;EACA,mBAAA;EACA,8EAAA;EACA,eAAA;EACA,sEAAA;ADukBF;;ACnjBA;EAfE,sEAAA;ADskBF;AC7jBE;EACE,2CAAA;AD+jBJ;;ACtjBA;EAnBE,+DAAA;AD6kBF;ACpkBE;EACE,oCAAA;ADskBJ;;ACzjBA;EAvBE,kEAAA;ADolBF;AC3kBE;EACE,uCAAA;AD6kBJ;;AC5jBA;EA3BE,kEAAA;AD2lBF;ACllBE;EACE,uCAAA;ADolBJ;;AC/jBA;EA/BE,kEAAA;ADkmBF;ACzlBE;EACE,uCAAA;AD2lBJ;;AClkBA;EAnCE,gEAAA;ADymBF;AChmBE;EACE,qCAAA;ADkmBJ;;ACpkBE;EACE,aAAA;ADukBJ;;AAnoBA;EACE,cAAA;AAsoBF;;AAnoBA;EACE,aAAA;AAsoBF;;AAnoBA;EACE,WAAA;AAsoBF;AApoBE;EACE,cAAA;AAsoBJ;;AAloBA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;AAqoBF;AAloBE;;EAEE,qBAAA;EACA,eAAA;AAooBJ;AAhoBI;EACE,cAAA;AAkoBN;AA9nBE;EACE,cAAA;AAgoBJ;AA9nBI;;EAEE,cAAA;AAgoBN;AA9nBM;;EACE,gBAAA;AAioBR;AA1nBI;EACE,sBAAA;AA4nBN;AA1nBM;EACE,yBAAA;AA4nBR;AAxnBI;EACE,sBAAA;AA0nBN;AAvnBI;EAEE,gBAAA;AAwnBN;AArnBI;EACE,gBAAA;AAunBN;AApnBI;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;AAsnBN;AAnnBI;EACE,sBAAA;EACA,WAAA;EACA,YAAA;AAqnBN;AA/mBI;EACE,4DAAA;AAinBN;AA9mBI;EACE,iDAAA;AAgnBN;AA3mBE;EACE,WAAA;AA6mBJ;AA1mBE;EACE,mBAAA;AA4mBJ;AAzmBE;EACE,cAAA;EACA,iBAAA;AA2mBJ;AAxmBE;EACE,aAAA;AA0mBJ;AAvmBE;EACE,WAAA;AAymBJ;AAtmBE;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;AAwmBJ;AAtmBI;EACE,6BAAA;EACA,kEAAA;AAwmBN;AApmBE;EACE,6DAAA;AAsmBJ;AApmBI;EACE,2DAAA;AAsmBN;AAlmBE;EACE,yEAAA;AAomBJ;AAjmBE;EACE,6DAAA;AAmmBJ;AAhmBE;EACE,sEAAA;AAkmBJ;AA/lBE;EACE,aAAA;EACA,uBAAA;AAimBJ;AA1lBI;EACE,aAAA;AA4lBN;;AAplBE;EACE,wDAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;AAulBJ;AArlBI;EACE,6HAAA;AAulBN;AAnlBE;;EAEE,uBAAA;AAqlBJ;AAllBE;EACE,eAAA;AAolBJ;AAhlBI;EACE,kDAAA;AAklBN;AA/kBI;EACE,yBAAA;AAilBN;AA5kBE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;AA8kBJ;AA3kBE;EACE,aAAA;AA6kBJ;AA1kBE;EACE,qDAAA;AA4kBJ;AAzkBE;EACE,aAAA;AA2kBJ;AAvkBE;EACE,aAAA;AAykBJ;AAvkBI;EACE,4EAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;AAykBN;AArkBE;EACE,8CAAA;AAukBJ;AApkBE;EACE,YAAA;EACA,UAAA;EACA,aAAA;AAskBJ;AAnkBE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAqkBJ;AAlkBE;EACE,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;EACA,8DAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAokBJ;AAlkBI;EACE,cAAA;AAokBN;AAjkBI;EACE,+DAAA;EACA,gFAAA;AAmkBN;AAjkBM;EACE,gBAAA;AAmkBR;AA/jBI;EACE,4DAAA;EACA,oDAAA;EACA,aAAA;AAikBN;AA9jBI;EAEE,UAAA;AA+jBN;AA5jBI;EACE,uBAAA;AA8jBN;;AAzjBA;EACE,aAAA;AA4jBF;;AAtjBI;EACE,+CAAA;AAyjBN;;AAljBE;EACE,aAAA;AAqjBJ;AAljBE;EACE,YAAA;AAojBJ;AAjjBE;EACE,gCAAA;AAmjBJ;AA/iBI;EACE,oBAAA;EACA,YAAA;AAijBN;AA5iBI;EACE,oBAAA;EACA,YAAA;AA8iBN;AAziBI;EACE,aAAA;AA2iBN;AAxiBI;EACE,mBAAA;EACA,YAAA;AA0iBN;AAriBI;EACE,mBAAA;EACA,YAAA;AAuiBN;;AAliBA;;EAEE,2CAAA;AAqiBF;;AAliBA;EAEI;;IAEE,sBAAA;IACA,uBAAA;EAoiBJ;EAjiBE;;IAEE,WAAA;EAmiBJ;AACF","sourcesContent":["// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n    gap: 8px;\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    + .validation-message {\n      min-width: min-content;\n      margin-block-start: calc(0px - var(--ids-space-2xs));\n      margin-inline-start: calc(var(--ids-label-width) + 6px);\n    }\n\n    &.xs + .validation-message {\n      position: relative;\n      inset-inline-start: 6px;\n      margin-inline-start: calc(var(--ids-label-width));\n    }\n\n    .ids-label-text {\n      margin-bottom: unset;\n\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-sm) {\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n      }\n\n      &.wrapped {\n        .validation-message {\n          margin-block-start: calc(0px - var(--ids-space-2xs));\n          margin-inline-start: calc(var(--ids-label-width) + 6px);\n        }\n      }\n    }\n  }\n\n\n  .ids-checkbox {\n    container-type: inline-size;\n    margin-top: var(--ids-space-00);\n\n    @container (width >= 200px) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      // Adjust the label\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n\n      @container (width < #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      @media (width < $breakpoint-xs) {\n        justify-content: flex-start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n        }\n      }\n    }\n\n    @container (width < #{$breakpoint-xs}) {\n      display: block;\n    }\n\n    @media (width < $breakpoint-xs) {\n      display: block;\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n\n  .ids-input:not(.xs) {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-space-2, 0.5rem);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']),\n  :host([label-position='inline-end']) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  :host([label-position='inline-end']) .ids-radio-group {\n    ids-text.group-label-text {\n      justify-content: end;\n      order: 2;\n    }\n\n    slot {\n      order: 1;\n    }\n  }\n}\n\n\n@media (width < $breakpoint-sm) {\n  :host([label-position='inline-end']):not([label-break]) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n      flex-direction: column;\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        order: 1;\n      }\n    }\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: 45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n","@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n@use '../../themes/mixins/ids-field-indicator-mixin' as *;\n\n:host {\n  display: block;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host([size='full']:not([label-position=\"inline-start\"])) {\n  width: 100%;\n\n  ::part(container) {\n    display: block;\n  }\n}\n\n.ids-date-picker {\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n\n  // Fixes input doesn't stretch to lg size and up\n  ids-trigger-field,\n  .ids-trigger-field {\n    display: inline-block;\n    max-width: 100%;\n  }\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n\n      &::part(container) {\n        flex-basis: 100%;\n      }\n    }\n  }\n\n  // Trigger button styling\n  ids-trigger-button {\n    &[field-height=\"xs\"] {\n      margin-inline-end: 2px;\n\n      &::part(button) {\n        inset-inline-start: unset;\n      }\n    }\n\n    &[field-height=\"md\"] {\n      margin-inline-end: 2px;\n    }\n\n    &.xs,\n    &.md {\n      margin-top: -2px;\n    }\n\n    &.sm {\n      margin-top: -1px;\n    }\n\n    &::part(button) {\n      block-size: 28px;\n      inline-size: 28px;\n      margin-inline-start: -10px;\n      inset-inline-end: -1px;\n      color: var(--ids-date-picker-icon-color);\n      position: relative;\n    }\n\n    &[compact] {\n      margin-inline-end: 2px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  // Is open state\n  &.is-open:not(.is-dropdown) {\n    ids-trigger-button::part(button) {\n      color: var(--ids-date-picker-open-trigger-button-color-text);\n    }\n\n    ids-trigger-field::part(field-container) {\n      border-color: var(--ids-date-picker-color-border);\n    }\n  }\n\n  // Popup related\n  ids-month-view {\n    width: 100%;\n  }\n\n  &:not(.has-time) ids-month-view::part(table-container) {\n    margin-bottom: 10px;\n  }\n\n  ids-popup::part(popup) {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .popup-footer {\n    display: flex;\n  }\n\n  .popup-btn {\n    width: 100%;\n  }\n\n  .popup-btn::part(button) {\n    display: flex;\n    padding-block: var(--ids-space-12);\n    border-radius: 0;\n    justify-content: center;\n\n    &:not(:focus) {\n      border: 1px solid transparent;\n      border-top-color: var(--ids-date-picker-popup-button-color-border);\n    }\n  }\n\n  .popup-btn:not(.popup-btn-apply)::part(button) {\n    color: var(--ids-date-picker-popup-button-color-text-default);\n\n    &:hover {\n      color: var(--ids-date-picker-popup-button-color-text-hover);\n    }\n  }\n\n  .popup-btn:not([hidden]):not(:last-child):not(:focus)::part(button) {\n    border-inline-end-color: var(--ids-date-picker-popup-button-color-border);\n  }\n\n  .popup-btn-apply:not([disabled])::part(button) {\n    color: var(--ids-date-picker-popup-button-primary-color-text);\n  }\n\n  .popup-btn-apply[disabled]::part(button) {\n    color: var(--ids-date-picker-popup-button-primary-color-text-disabled);\n  }\n\n  ids-time-picker {\n    display: flex;\n    justify-content: center;\n  }\n\n  &.field-height-xs,\n  &.field-height-sm,\n  &.field-height-md,\n  &.field-height-lg {\n    ids-trigger-field {\n      display: flex;\n    }\n  }\n}\n\n// Dropdown\n.ids-date-picker.is-dropdown {\n  // Button\n  .dropdown-btn::part(button) {\n    color: var(--ids-date-picker-dropdown-button-color-text);\n    padding: 4px;\n    border: none;\n    border-radius: var(--ids-border-radius-2xs);\n\n    &:focus {\n      box-shadow: 0 0 0 2px transparent, 0 0 0 1px var(--ids-date-picker-dropdown-color-focus), 0 0 4px 3px rgb(54 138 192 / 0.3);\n    }\n  }\n\n  .dropdown-btn-text,\n  .dropdown-btn-icon {\n    padding-inline-start: 0;\n  }\n\n  .dropdown-btn-icon {\n    margin-top: 2px;\n  }\n\n  &.is-expanded {\n    .dropdown-btn::part(button) {\n      color: var(--ids-button-tertiary-color-text-hover);\n    }\n\n    .dropdown-btn-icon {\n      transform: rotate(180deg);\n    }\n  }\n\n  // Expandable area\n  ids-expandable-area::part(container) {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    position: absolute;\n    z-index: 3;\n    border: none;\n    top: 43px;\n    left: 0;\n  }\n\n  ids-expandable-area::part(header) {\n    display: none;\n  }\n\n  ids-expandable-area::part(pane) {\n    background-color: var(--ids-color-background-default);\n  }\n\n  ids-expandable-area::part(pane-content) {\n    margin-top: 0;\n  }\n\n  // Picklist\n  .picklist {\n    display: flex;\n\n    &::after {\n      background-color: var(--ids-date-picker-picklist-separator-color-background);\n      position: absolute;\n      content: ' ';\n      width: 1px;\n      left: 0;\n      right: 0;\n      margin-left: auto;\n      margin-right: auto;\n      height: calc(75% + 14px);\n      top: calc(12.5% - 4px);\n    }\n  }\n\n  &:not(.is-expanded) .picklist::after {\n    background-color: var(--ids-color-transparent);\n  }\n\n  .picklist-section {\n    height: 100%;\n    width: 50%;\n    flex: 0 0 50%;\n  }\n\n  .picklist-list {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    height: 100%;\n  }\n\n  .picklist-item {\n    border: 1px solid transparent;\n    box-sizing: border-box;\n    display: flex;\n    cursor: var(--ids-cursor-pointer);\n    color: var(--ids-date-picker-picklist-item-color-text-default);\n    padding-top: 1px;\n    padding-bottom: 1px;\n    user-select: none;\n    height: 12.5%;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n\n    ids-text {\n      line-height: 0;\n    }\n\n    &.is-selected {\n      color: var(--ids-date-picker-picklist-item-color-text-selected);\n      background-color: var(--ids-date-picker-picklist-item-color-background-selected);\n\n      ids-text::part(text) {\n        font-weight: 600;\n      }\n    }\n\n    &:focus {\n      border-color: var(--ids-date-picker-item-color-border-focus);\n      box-shadow: var(--ids-date-picker-item-shadow-focus);\n      outline: none;\n    }\n\n    &.is-year-nav,\n    &.is-month-nav {\n      z-index: 1;\n    }\n\n    &.is-month-nav {\n      width: calc(100% + 1px);\n    }\n  }\n}\n\n:host([is-calendar-toolbar='true']) {\n  display: flex;\n}\n\n// Text direction\n:host([dir='rtl']) {\n  .ids-date-picker {\n    .popup-btn + .popup-btn::part(button):not(:focus) {\n      border-left-color: var(--ids-color-transparent);\n    }\n  }\n}\n\n// Date Picker Editor Borderless\n.ids-date-picker.color-variant-borderless {\n  ids-trigger-field::part(container) {\n    margin: 1px 0;\n  }\n\n  ids-trigger-field::part(field-container) {\n    border: none;\n  }\n\n  ids-trigger-field::part(input) {\n    padding-inline-end: 0 !important;\n  }\n\n  &.field-height-lg {\n    ids-trigger-field::part(input) {\n      padding-inline: 16px;\n      height: 50px;\n    }\n  }\n\n  &.field-height-md {\n    ids-trigger-field::part(input) {\n      padding-inline: 12px;\n      height: 40px;\n    }\n  }\n\n  &.field-height-sm {\n    ids-trigger-field::part(container) {\n      display: flex;\n    }\n\n    ids-trigger-field::part(input) {\n      padding-inline: 8px;\n      height: 35px;\n    }\n  }\n\n  &.field-height-xs {\n    ids-trigger-field::part(input) {\n      padding-inline: 4px;\n      height: 30px;\n    }\n  }\n}\n\n:host([field-indicator][readonly]),\n:host([field-indicator][disabled]) {\n  --ids-field-indicator-info-visibility: none;\n}\n\n@media (width <= 767px) {\n  :host(:not([label-position=\"inline-start\"])) {\n    ids-trigger-field::part(container),\n    ids-input::part(container) {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    ids-trigger-field:not(.ids-date-picker ids-trigger-field)::part(field-container),\n    ids-input::part(field-container) {\n      width: 100%;\n    }\n  }\n}\n","// Field Indicator icon placement\n.icon-field-indicator {\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n\n.icon-field-indicator-info {\n  display: var(--ids-field-indicator-info-visibility, flex);\n  align-items: center;\n  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));\n  cursor: pointer;\n  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);\n}\n\n// Mixin to apply field indicator color variables\n@mixin field-indicator-color($color, $border-color: null) {\n  --ids-field-indicator-icon-color: #{$color};\n\n  @if $border-color {\n    --ids-input-border-default-color: #{$border-color};\n    --ids-input-color-border-hover: #{$border-color};\n    --ids-input-color-border-disabled: #{$border-color};\n    --ids-input-color-border-focus: #{$border-color};\n  }\n\n  .icon-field-indicator {\n    color: #{$color};\n  }\n}\n\n// Field indicator type classes — applied to the field container.\n.field-indicator-neutral {\n  @include field-indicator-color(var(--ids-color-accent-neutral-weak));\n}\n\n.field-indicator-info {\n  @include field-indicator-color(var(--ids-color-info-default));\n}\n\n.field-indicator-success {\n  @include field-indicator-color(var(--ids-color-success-default));\n}\n\n.field-indicator-caution {\n  @include field-indicator-color(var(--ids-color-caution-default));\n}\n\n.field-indicator-warning {\n  @include field-indicator-color(var(--ids-color-warning-default));\n}\n\n.field-indicator-error {\n  @include field-indicator-color(var(--ids-color-error-default));\n}\n\n[class*=\"field-indicator-\"].has-focus {\n  .icon-field-indicator-info {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
